import { Plugin, ButtonView } from 'ckeditor5'
import { PatchContent, PatchData } from 'src/model/patch'

import ContainerMediaGalery from 'src/container/video-gallery'

import { track } from '@amplitude/analytics-browser'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'

import {
  videoGalleryChangeIcon,
  videoGalleryAddIcon,
  aspectRatioIcon,
  videoGalleryLinkIcon,
} from './svg'
import Embed from '../../embed'

const handleChangeVideo = (dispatch, editor) => {
  track('media_gallery_in_editor_clicked')

  /**
   *
   * @param {} items
   */
  const onOk = item => {
    const itemUrl = item[0].link

    if (editor) {
      const selection = editor.model.document.selection

      // Check if an image is selected
      const selectedElement = selection.getSelectedElement()
      const aspectRatioFirstValue =
        selectedElement.getAttribute('aspectratio') || ''
      editor.model.change(writer => {
        const videoPlayer = writer.createElement('videoPlayer', {
          src: itemUrl,
          aspectratio: aspectRatioFirstValue,
        })
        editor.model.insertContent(videoPlayer)
      })
    }

    dispatch(messageBoxHideAction())
  }
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        buttons: [],
        title: `
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
         
          <Icon
            icon="ic:round-add-a-photo"
            color="#00AB55"
            width="24"
            height="24"
          />
          <Typography
            style="
              margin-left: 8;
              color: #002E47;
              fontWeight: 600;
              fontSize: 16;
            "
          >
            Media Gallery
          </Typography>
        </div>`,
        component: <ContainerMediaGalery onOk={onOk} />,
        maxHeight: '70vh',
        draggable: true,
      }),
    ),
  )
}

const handleLinkVideo = (dispatch, editor, modalData) => {
  const selection = editor.model.document.selection

  const onOk = item => {
    const itemUrl = item

    if (editor) {
      const model = editor.model
      const selection = model.document.selection
      editor.model.change(writer => {
        const videoWrapper = writer.createElement('videoWrapper')

        const figure = writer.createElement('media', {
          url: itemUrl,
        })
        writer.append(figure, videoWrapper)

        editor.model.insertContent(videoWrapper)
      })
    }

    dispatch(messageBoxHideAction())
  }

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: ``,
        buttons: [],
        component: (
          <Embed
            modalData={modalData}
            onEmbed={url => {
              onOk(url, selection, modalData, editor)
              dispatch(messageBoxHideAction())
            }}
          />
        ),
        callback: () => {},
      }),
    ),
  )
}

const handleChangeAspectRatio = editor => {
  track('change_video_aspect_ratio')

  const selection = editor.model.document.selection

  // Check if an image is selected
  const selectedElement = selection.getSelectedElement()

  const src = selectedElement.getAttribute('src') || ''
  const aspectRatioFirstValue =
    selectedElement.getAttribute('aspectratio') || ''

  let aspectRatio = '16/9'

  if (aspectRatioFirstValue == '16/9') {
    aspectRatio = '9/16'
  } else {
    aspectRatio = '16/9'
  }

  if (editor) {
    editor.model.change(writer => {
      const videoPlayer = writer.createElement('videoPlayer', {
        src: src,
        aspectratio: aspectRatio,
      })
      editor.model.insertContent(videoPlayer)
    })
  }
}

class VideoGalleryPlugin extends Plugin {
  constructor(editor) {
    super(editor)
    this.dispatch = editor.config.get('videoGalleryPlugin.dispatch')
  }
  init() {
    const editor = this.editor

    editor.ui.componentFactory.add('videoGalleryChange', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Upload from computer',
        icon: videoGalleryChangeIcon,
        tooltip: true,
        class: 'change-video',
      })

      view.on('execute', () => {
        handleChangeVideo(this.dispatch, this.editor)
        editor.execute('openVideoGallery')
      })

      return view
    })

    editor.ui.componentFactory.add('videoGalleryLink', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Insert via URL',
        icon: videoGalleryLinkIcon,
        tooltip: true,
        class: 'link-video',
      })
      const modalData = {
        name: 'Insert video via URL',
        value: 'insertViaUrl',
        image: '',
        modalImg: '/assets/editor-file/embed/video-insert-via-com.png',
        html: '&nbsp;',
        message: 'Paste YouTube or Vimeo link.',
        url: '',
      }
      view.on('execute', () => {
        handleLinkVideo(this.dispatch, this.editor, modalData)
        editor.execute('openVideoGallery')
      })

      return view
    })

    editor.ui.componentFactory.add('videoGalleryAdd', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Upload from computer',
        icon: videoGalleryAddIcon,
        withText: true,
        tooltip: true,
        class: 'videoGalleryAdd',
      })
      view.on('execute', () => {
        handleChangeVideo(this.dispatch, this.editor)
        editor.execute('openVideoGallery')
      })

      return view
    })

    editor.ui.componentFactory.add('aspectRatio', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: `Aspect Ratio`,
        icon: aspectRatioIcon,
        tooltip: true,
      })

      view.on('execute', () => {
        handleChangeAspectRatio(this.editor)
        //editor.execute('openVideoGallery')
      })

      return view
    })

    editor.commands.add('openVideoGallery', {
      execute: () => {
        if (editor.config.get('videoGalleryHandler')) {
          editor.config.get('videoGalleryHandler')()
        }
      },
    })
  }
}

export default VideoGalleryPlugin
